import type { TechnicalEnvironment } from '../types/content';

export const technicalEnvironments: TechnicalEnvironment[] = [
  { label: 'Worldwide Satellite & Fiber Broadcasting' },
  { label: 'IP Distribution' },
  { label: 'OTT Architectures' },
  { label: 'FAST Channels' },
  { label: 'Hybrid Delivery Systems' }
];
